/* ============================================================
   Clay Paw Print Kit — shared behaviour
   Progressive enhancement only. Everything renders & is usable
   without JS; this layer adds the animations & interactivity
   from the original design. All timings are read from the DOM
   so they stay editable in the Theme Editor.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal on scroll ---------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.paw-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Accordions ---------------------------------------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-paw-acc]').forEach(function (acc) {
      acc.querySelectorAll('.paw-acc__head').forEach(function (head) {
        if (head.__pawBound) return;
        head.__pawBound = true;
        head.addEventListener('click', function () {
          var open = head.getAttribute('aria-expanded') === 'true';
          if (!acc.hasAttribute('data-paw-multi')) {
            acc.querySelectorAll('.paw-acc__head[aria-expanded="true"]').forEach(function (h) {
              if (h !== head) h.setAttribute('aria-expanded', 'false');
            });
          }
          head.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  /* ---- Countdown ----------------------------------------- */
  function initCountdown(scope) {
    (scope || document).querySelectorAll('[data-paw-countdown]').forEach(function (el) {
      if (el.__pawBound) return;
      el.__pawBound = true;
      var start = parseInt(el.getAttribute('data-paw-countdown'), 10) || (45 * 60 + 56);
      var reset = parseInt(el.getAttribute('data-paw-reset'), 10) || (59 * 60 + 59);
      var t = start;
      function tick() {
        t = t <= 0 ? reset : t - 1;
        var m = String(Math.floor(t / 60)).padStart(2, '0');
        var s = String(t % 60).padStart(2, '0');
        el.textContent = m + ':' + s;
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---- Reviews carousel ---------------------------------- */
  function initCarousel(scope) {
    (scope || document).querySelectorAll('[data-paw-carousel]').forEach(function (car) {
      if (car.__pawBound) return;
      car.__pawBound = true;
      var track = car.querySelector('[data-paw-track]');
      var prev = car.querySelector('[data-paw-prev]');
      var next = car.querySelector('[data-paw-next]');
      if (!track) return;
      var i = 0;
      function count() { return track.children.length; }
      function step() {
        var first = track.children[0];
        if (!first) return 384;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 24) || 24;
        return first.getBoundingClientRect().width + gap;
      }
      function perView() {
        return Math.max(1, Math.floor(car.getBoundingClientRect().width / step()));
      }
      function max() { return Math.max(0, count() - perView()); }
      function go() {
        i = Math.min(Math.max(i, 0), max());
        track.style.transform = 'translateX(' + (-i * step()) + 'px)';
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= max();
      }
      if (prev) prev.addEventListener('click', function () { i--; go(); });
      if (next) next.addEventListener('click', function () { i++; go(); });
      window.addEventListener('resize', go);
      go();
    });
  }

  /* ---- Bundle selector + cart ---------------------------- */
  function initBundles(scope) {
    (scope || document).querySelectorAll('[data-paw-buy]').forEach(function (root) {
      if (root.__pawBound) return;
      root.__pawBound = true;

      var form = root.querySelector('[data-paw-form]');
      var idInput = root.querySelector('[data-paw-variant-id]');
      var qtyInput = root.querySelector('[data-paw-qty]');
      var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-paw-bundle]'));
      var priceOut = document.querySelectorAll('[data-paw-price]');
      var compareOut = document.querySelectorAll('[data-paw-compare]');
      var atcLabels = root.querySelectorAll('[data-paw-atc-label]');
      var defaultLabel = atcLabels[0] ? atcLabels[0].textContent : 'Add to cart';

      function selectBundle(b) {
        bundles.forEach(function (x) {
          var on = x === b;
          x.setAttribute('data-selected', on ? 'true' : 'false');
          var extra = x.querySelector('[data-paw-bundle-extra]');
          if (extra) extra.hidden = !on;
        });
        if (idInput && b.getAttribute('data-variant')) idInput.value = b.getAttribute('data-variant');
        if (qtyInput) qtyInput.value = b.getAttribute('data-qty') || '1';
        var p = b.getAttribute('data-price'), c = b.getAttribute('data-compare');
        priceOut.forEach(function (el) { if (p) el.textContent = p; });
        compareOut.forEach(function (el) { if (c) el.textContent = c; });
      }

      bundles.forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (e.target.closest('select')) return;
          selectBundle(b);
        });
        b.querySelectorAll('select[data-paw-kit]').forEach(function (sel) {
          sel.addEventListener('click', function (e) { e.stopPropagation(); });
        });
      });
      var pre = bundles.filter(function (b) { return b.getAttribute('data-selected') === 'true'; })[0];
      selectBundle(pre || bundles[0] || root);

      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return; // allow native post
          e.preventDefault();
          var btns = form.querySelectorAll('[data-paw-atc]');
          btns.forEach(function (btn) { btn.setAttribute('aria-busy', 'true'); });
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(serialize(form))
          }).then(function (r) { return r.json(); }).then(function () {
            atcLabels.forEach(function (el) { el.textContent = 'Added ✓'; });
            document.dispatchEvent(new CustomEvent('paw:added'));
            openCartDrawerOrRedirect();
            setTimeout(function () { atcLabels.forEach(function (el) { el.textContent = defaultLabel; }); }, 1800);
          }).catch(function () { form.submit(); })
            .finally(function () { btns.forEach(function (btn) { btn.removeAttribute('aria-busy'); }); });
        });
      }
    });
  }

  function serialize(form) {
    var data = { items: [{ id: '', quantity: 1, properties: {} }] };
    var id = form.querySelector('[data-paw-variant-id]');
    var qty = form.querySelector('[data-paw-qty]');
    data.items[0].id = id ? id.value : '';
    data.items[0].quantity = qty ? parseInt(qty.value, 10) || 1 : 1;
    form.querySelectorAll('select[data-paw-kit]').forEach(function (sel) {
      if (sel.closest('[data-selected="true"]')) {
        data.items[0].properties[sel.getAttribute('data-paw-kit')] = sel.value;
      }
    });
    if (!Object.keys(data.items[0].properties).length) delete data.items[0].properties;
    return data;
  }

  function openCartDrawerOrRedirect() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents !== 'function') { window.location.href = '/cart'; return; }
    fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (t) {
      try {
        var html = new DOMParser().parseFromString(t, 'text/html');
        if (drawer && drawer.renderContents) {
          var src = html.querySelector('#CartDrawer');
          if (src) { document.querySelector('#CartDrawer').innerHTML = src.innerHTML; }
          drawer.classList.remove('is-empty');
          drawer.open ? drawer.open() : drawer.classList.add('active', 'animate');
        }
      } catch (e) { window.location.href = '/cart'; }
    }).catch(function () { window.location.href = '/cart'; });
  }

  /* ---- Sticky ATC bar ------------------------------------ */
  function initSticky(scope) {
    (scope || document).querySelectorAll('[data-paw-sticky]').forEach(function (bar) {
      if (bar.__pawBound) return;
      bar.__pawBound = true;
      var anchorSel = bar.getAttribute('data-paw-sticky');
      var anchor = anchorSel ? document.querySelector(anchorSel) : null;
      function update() {
        var show = true;
        if (anchor) {
          var r = anchor.getBoundingClientRect();
          show = r.bottom < 40; // show once main CTA scrolled out
        }
        bar.setAttribute('data-visible', show ? 'true' : 'false');
      }
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  /* ---- Social proof toast -------------------------------- */
  function initToast(scope) {
    (scope || document).querySelectorAll('[data-paw-toast]').forEach(function (toast) {
      if (toast.__pawBound) return;
      toast.__pawBound = true;
      var names = (toast.getAttribute('data-names') || '').split('|').filter(Boolean);
      var cities = (toast.getAttribute('data-cities') || '').split('|').filter(Boolean);
      if (!names.length) return;
      var nameEl = toast.querySelector('[data-paw-toast-name]');
      var cityEl = toast.querySelector('[data-paw-toast-city]');
      var every = parseInt(toast.getAttribute('data-interval'), 10) || 5500;
      var i = 0, visible = false;
      function cycle() {
        visible = !visible;
        if (visible) {
          if (nameEl) nameEl.textContent = names[i % names.length];
          if (cityEl && cities.length) cityEl.textContent = cities[i % cities.length];
          i++;
        }
        toast.setAttribute('data-visible', visible ? 'true' : 'false');
      }
      setTimeout(cycle, 2500);
      setInterval(cycle, every);
    });
  }

  /* ---- Product gallery ----------------------------------- */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-paw-gallery]').forEach(function (gal) {
      if (gal.__pawBound) return;
      gal.__pawBound = true;
      var main = gal.querySelector('[data-paw-main]');
      gal.querySelectorAll('[data-paw-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (main && src) { main.src = src; main.alt = alt; }
          gal.querySelectorAll('[data-paw-thumb]').forEach(function (t) { t.setAttribute('data-active', 'false'); });
          thumb.setAttribute('data-active', 'true');
        });
      });
    });
  }

  /* ---- Theme editor + boot ------------------------------- */
  function boot(scope) {
    initReveal();
    initAccordions(scope);
    initCountdown(scope);
    initCarousel(scope);
    initGallery(scope);
    initBundles(scope);
    initSticky(scope);
    initToast(scope);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }

  // Re-init the specific section the merchant is editing
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); initReveal(); });
})();
